<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData && !state.loading">
      Semua TTB sudah ada marketing.
    </p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <h3 class="report-title mb-2">
        Laporan TTB Tanpa Marketing ({{ data.length }} TTB)
      </h3>
      <table width="100%" class="mb-2">
        <thead>
          <th>No</th>
          <th>Kode TTB</th>
          <th>No TTB</th>
          <th>Tgl</th>
          <th>Pengirim</th>
          <th>Penerima</th>
        </thead>
        <tbody>
          <tr v-for="(ttb, i) in data" :key="ttb.id">
            <td>{{ i + 1 }}</td>
            <td>{{ ttb.kodettb }}</td>
            <td>{{ ttb.nottb }}</td>
            <td>{{ formatDate(ttb.tgl) }}</td>
            <td>
              {{ (ttb.pengirim_detil && ttb.pengirim_detil.nama_lengkap) || "-" }}
            </td>
            <td>
              {{ (ttb.penerima_detil && ttb.penerima_detil.nama_lengkap) || "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TTBTanpaMarketingView",
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`laporan/ttb-tanpa-marketing`)
        .then(res => {
          this.data = res.data || [];
          this.state.noData = this.data.length <= 0;
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response?.data?.message || err.message);
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}
</style>

